import { useMemo } from 'react';
import { useAppSelector } from 'store/hook';

// takes in array of allowed roles and return a boolean wheather user can perform that action/have access
export const useRoleBasedAccess = (
  allowedRoles: string[] = ['director', 'internal-user', 'external-admin']
): boolean => {
  const currentRole = useAppSelector((state) => state.authReducer.role);

  const canAccess = useMemo(() => {
    if (!currentRole) return false;
    return allowedRoles.includes(currentRole);
  }, [currentRole, allowedRoles.join(',')]);

  return canAccess;
};
